import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import {
	adminUsersByIdLinksInvitationReducers,
	adminUsersByIdLinksInvitationWatchers } from './invitation';
import {
	adminUsersByIdLinksPasswordResetReducers,
	adminUsersByIdLinksPasswordResetWatchers } from './password-reset';

export const adminUsersByIdLinksReducers = combineReducers({
	invitation: adminUsersByIdLinksInvitationReducers,
	passwordReset: adminUsersByIdLinksPasswordResetReducers
});

export const adminUsersByIdLinksWatchers = combineAllWatchers([
	adminUsersByIdLinksInvitationWatchers,
	adminUsersByIdLinksPasswordResetWatchers
]);
